<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/admission-desktop-banners/Admission-Criteria.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/admission-desktop-banners/medium-screen/Admission-Criteria.webp">
        <img
            src="assets/img/admissions-mobile-banners/Admission%20Criteria%20(1).webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>
        <section class="flex-1 shadow-lg p-4 border-2 h-fit border-gray-200 bg-white text-justify px-6">
            <h1 class="text-2xl font-bold mb-4">ARNI University Admission Test 2025 – Process Details at Exam
                Centres</h1>
            <p class="mt-2 text-md font-semibold text-gray-800">ARNI University, established by the Government of
                Himachal Pradesh
                under Act No. 23 of 2009 and
                recognized by the University Grants Commission (UGC) under Section 2(f) of the UGC Act, 1956, offers a
                diverse range of programs.
            </p>
            <p class="font-bold">Enrollment and application</p>
            <ul class="pl-6 mt-2 space-y-2 list-[lower-roman] text-gray-800">
                <li>
                    The application form must be filled out and signed by the student and fee payer for the student to
                    be enrolled at the university. Include the following with your application when you submit it
                    directly to Admissions:
                    <ul class="pl-6 mt-2 space-y-1 list-[lower-alpha]">
                        <li>The student's complete academic records, including transcripts and reports, as well as
                            proof of proficiency in English
                        </li>
                        <li>Four photos the size of passports</li>
                    </ul>
                </li>
                <li>The University will promptly verify if the enrollment has been approved or denied.
                </li>
                <li>After your application is approved, you will receive official enrollment paperwork.</li>
            </ul>
            <p class="mt-2 text-xl font-semibold">The admission criteria for various programs are as
                follows:
            </p>
            <h2 class="text-xl font-semibold mt-4">Undergraduate Programs</h2>
            <p class="mt-2 text-gray-800">To enroll in ARNI’s undergraduate programs, the candidate must complete a 10+2
                or equivalent
                examination
                from a recognized board.
            </p>
            <ul class="list-disc pl-6 mt-2 space-y-2 text-gray-800">
                <li> Bachelor of Technology (B.Tech): Candidates must have completed 10+2 with Physics, Chemistry, and
                    Mathematics, securing a minimum of 45% aggregate marks. Admission is based on merit and entrance
                    examinations such as JEE Main or HPCET.
                </li>
                <li> Bachelor of Science (B.Sc): Applicants should have passed 10+2 in the Science stream with at least
                    50% aggregate marks. Specific specializations may have additional requirements.
                </li>
                <li> Bachelor of Science (B.Sc): Applicants should have passed 10+2 in the Science stream with at least
                    50% aggregate marks. Specific specializations may have additional requirements.
                </li>
            </ul>
            <h2 class="text-xl font-semibold mt-4">Postgraduate Programs</h2>
            <p class="mt-2 font-semibold text-gray-800">Bachelor’s degree in the relevant field from a recognized
                university.
            </p>
            <ul class="list-disc pl-6 mt-2 space-y-2 text-gray-800">
                <li>Master of Technology (M.Tech): A B.Tech degree in the relevant field with a minimum of 50% aggregate
                    marks is necessary. Admission is through GATE, HPCET, or the university's entrance exam (AUCET).
                </li>
                <li> Master of Business Administration (MBA): Candidates must hold a bachelor's degree with at least 50%
                    marks. Admission is based on scores from CMAT, MAT, HPCET, or AUCET.
                </li>
                <li>Master of Science (M.Sc): Applicants should have a B.Sc degree in the relevant discipline with a
                    minimum of 50% aggregate marks.
                </li>
                <li>Master of Arts (M.A.): A B.A degree in the concerned subject with at least 50% marks is required.
                </li>
            </ul>
            <h2 class="text-xl font-semibold mt-4">Doctoral Programs</h2>
            <p class="mt-2 text-gray-800">Master’s degree in the relevant field with a minimum of 55% marks (50% for
                reserved categories).
            </p>
            <p class="mt-2 text-gray-800">Doctor of Philosophy (Ph.D.): Candidates must possess a master's degree with a
                minimum of
                55% marks or an
                equivalent grade. Admission is based on an entrance test followed by an interview, following UGC
                regulations.
            </p>
            <h2 class="text-xl font-semibold mt-4">Diploma and Certificate Programs</h2>
            <p class="mt-2 text-gray-800">ARNI University offers various diploma and certificate courses across
                disciplines such as
                Engineering, Pharmacy, Digital Marketing, and more. Eligibility criteria vary by program, generally
                requiring completion of 10th or 10+2 education.
            </p>
            <p class="mt-2 text-gray-800">
                For detailed information on specific programs and to apply online, please visit our official
                website or contact our admission helpline at
                <a href="tel:18008918962" class="text-blue-600 hover:underline">1800-891-8962</a>.
            </p>
        </section>
    </div>
</div>
